import { useTranslation } from 'react-i18next';

import { DfiAnnualReport, DfiReportResponse, TqEnAnnualReportResponse } from 'types';
import { useTQFormattedDfiReport } from './fragments/useTQFormattedDfiReport';
import { useNorthernIrelandFormattedDfiReport } from './fragments/useNorthernIrelandFormattedDfiReport';

export const useFormattedDfiReport = (
  reportResponse: DfiReportResponse | TqEnAnnualReportResponse
): {
  report: DfiAnnualReport | undefined;
  titles: Record<string, string>;
  metrics: Record<string, unknown>;
} => {
  const { t } = useTranslation('annual_dfi_report');

  const { formattedReport, metrics, titles } = useNorthernIrelandFormattedDfiReport(
    reportResponse,
    t
  );

  const { tqFormattedReport, tqEnMetrics, tqTitles } = useTQFormattedDfiReport(
    reportResponse,
    t
  );

  return {
    report: tqFormattedReport ?? formattedReport,
    titles: tqTitles ?? titles ?? {},
    metrics: tqEnMetrics ?? metrics ?? {},
  };
};
